import { useEffect, useRef } from 'react'

/**
 * Calls `init(serverValue)` on first mount and on each real reference
 * change. Skips the re-fire that Activity hide/show triggers, which would
 * stomp in-flight user edits.
 */
export function useInitFromServer<T>(
  serverValue: T | null | undefined,
  init: (value: T) => void
): void {
  const lastInitRef = useRef<T | null | undefined>(undefined)
  useEffect(() => {
    if (serverValue == null) return
    if (lastInitRef.current === serverValue) return
    lastInitRef.current = serverValue
    init(serverValue)
  }, [serverValue, init])
}
